export default "__VITE_ASSET__b2b18d7b__"